import React, { Component } from 'react';

class Quote extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="section quote-section">
        <div className="container quote-container">
          <div className="columns quote-wrapper">
            <div className="column is-10 quote-content">
              {data.title && <div className="item-title">{data.title}</div>}
              {data.quote && <h1 className="item-quote">"{data.quote}"</h1>}

              {(data.author || data.image) && (
                <div className="column is-10 author-wrapper">
                  {data.image?.childImageSharp?.fluid?.src || data.image ? (
                    <img
                      className="author-image"
                      src={data.image.childImageSharp?.fluid?.src || data.image}
                      alt={data.author || "Author Image"}
                    />
                  ) : (
                    <span className="author-item" style={{ paddingRight:"0.35rem" }}>-</span>
                  )}
                  {data.author && <div className="author-item"> {data.author}</div>}
                </div>
              )}

              {data.buttonlink && data.buttontxt && (
                <a href={data.buttonlink} className="quote-button">
                  <button className="btn-golden item-button">{data.buttontxt}</button>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Quote;
